export default __webpack_public_path__ + "static/media/supplier.0ddde283.svg";